import React from "react";
import {Link, withRouter} from "react-router-dom";
import {useTranslation} from 'react-i18next'



const Main = () => {

    const {t} = useTranslation()
    return (
        <div>
            {process.env.REACT_APP_NOT_SECRET_CODE}
            <h2 className="m-3" style={{textAlign: 'center'}}>{t('top_biocollection_name')}</h2>
            <br/>
            <div style={{textAlign: 'left'}}>{t("index_text")}</div>
            <br/>
        </div>
    );
};
export default Main;